"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var personalNumber_1 = require("./personalNumber");
var corporateIdentityNumber_1 = require("./corporateIdentityNumber");
function parse(input, options) {
    if (!options) {
        options = {};
    }
    return personalNumber_1.parse(input, options);
}
exports.parse = parse;
function validate(input, options) {
    if (!options) {
        options = {};
    }
    return parse(input, options).valid;
}
exports.validate = validate;
function normalise(input, options) {
    if (!options) {
        options = {};
    }
    var pn = parse(input, options);
    if (pn.valid) {
        return pn.normalised;
    }
    else {
        return "";
    }
}
exports.normalise = normalise;
function parseCIN(input) {
    var cin = corporateIdentityNumber_1.parse(input);
    var pn;
    if (cin.valid) {
        return cin;
    }
    else {
        pn = parse(input, { strict: true });
    }
    if (pn.valid) {
        pn.type = "Enskild firma";
        return pn;
    }
    return cin;
}
exports.parseCIN = parseCIN;
function validateCIN(input) {
    var cin = corporateIdentityNumber_1.parse(input);
    var pn;
    if (cin.valid) {
        return true;
    }
    else {
        pn = parse(input, { strict: true });
    }
    if (pn.valid) {
        return true;
    }
    return false;
}
exports.validateCIN = validateCIN;
function normaliseCIN(input) {
    var cin = corporateIdentityNumber_1.parse(input);
    var pn;
    if (cin.valid) {
        return cin.normalised;
    }
    else {
        pn = parse(input, { strict: true });
    }
    if (pn.valid) {
        return pn.normalised;
    }
    return "";
}
exports.normaliseCIN = normaliseCIN;
exports.default = { parse: parse, validate: validate, normalise: normalise, parseCIN: parseCIN, validateCIN: validateCIN, normaliseCIN: normaliseCIN };
